var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import '../icon-button/icon-button.js';
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { when } from 'lit/directives/when.js';
import { SgdfElement } from '../../internal/sgdf-element.js';
import styles from './text-bloc.styles.js';
/**
 * @since 0.1
 * @status stable
 *
 * @dependency sgdf-icon-button
 *
 * @slot - The text-bloc's content.
 *
 * @csspart base - The component's base wrapper.
 * @csspart content - The text-bloc content.
 * @csspart remove-button - The remove button.
 */
let SgdfTextBloc = class SgdfTextBloc extends SgdfElement {
    constructor() {
        super(...arguments);
        this.primary = false;
        this.success = false;
        this.neutral = false;
        this.warning = false;
        this.danger = false;
        this.overrideContent = false;
        this.size = 'medium';
    }
    render() {
        const modes = {
            primary: this.primary &&
                !this.success &&
                !this.neutral &&
                !this.warning &&
                !this.danger,
            success: !this.primary &&
                this.success &&
                !this.neutral &&
                !this.warning &&
                !this.danger,
            neutral: !this.primary &&
                !this.success &&
                this.neutral &&
                !this.warning &&
                !this.danger,
            warning: !this.primary &&
                !this.success &&
                !this.neutral &&
                this.warning &&
                !this.danger,
            danger: !this.primary &&
                !this.success &&
                !this.neutral &&
                !this.warning &&
                this.danger,
            'text-bloc': true,
            // Sizes
            'text-bloc--small': this.size === 'small',
            'text-bloc--medium': this.size === 'medium',
            'text-bloc--large': this.size === 'large',
        };
        // simple mode is default when no value or when there are multiple conflicting values
        modes.simple =
            !this.primary &&
                !modes.success &&
                !this.neutral &&
                !modes.warning &&
                !modes.danger;
        return html `
            <div part="base" class=${classMap(modes)}>
                ${when(this.overrideContent, () => html `<slot></slot>`, () => html `
                        <p part="content" class="text-bloc__content">
                            <slot name="icon"></slot>
                            <slot></slot>
                        </p>
                    `)}
            </div>
        `;
    }
};
SgdfTextBloc.styles = styles;
__decorate([
    property({ type: Boolean })
], SgdfTextBloc.prototype, "primary", void 0);
__decorate([
    property({ type: Boolean })
], SgdfTextBloc.prototype, "success", void 0);
__decorate([
    property({ type: Boolean })
], SgdfTextBloc.prototype, "neutral", void 0);
__decorate([
    property({ type: Boolean })
], SgdfTextBloc.prototype, "warning", void 0);
__decorate([
    property({ type: Boolean })
], SgdfTextBloc.prototype, "danger", void 0);
__decorate([
    property({ type: Boolean, attribute: 'override-content' })
], SgdfTextBloc.prototype, "overrideContent", void 0);
__decorate([
    property({ reflect: true })
], SgdfTextBloc.prototype, "size", void 0);
SgdfTextBloc = __decorate([
    customElement('sgdf-text-bloc')
], SgdfTextBloc);
export default SgdfTextBloc;
//# sourceMappingURL=text-bloc.js.map